import React, { useState, useRef, useEffect } from "react";
import DataTable from "react-data-table-component";
import { endPoints } from "../../../constant/Environment";
import { addData, getAllData } from "../../../Utility/API";
import { Form, Button, Row, Col } from "react-bootstrap";
import Toaster from "../../../components/Toast";
import Loader from "../../../components/Loader";
import { SuccesToast } from "../../../components/Toast/message";
const RoleData = [
  {
    id: 1,
    name: "Operator01",
    value: "Operator01",
  },
  {
    id: 2,
    name: "Operator02",
    value: "Operator02",
  },
  {
    id: 3,
    name: "Operator03",
    value: "Operator03",
  },
  {
    id: 4,
    name: "Operator04",
    value: "Operator04",
  },
  {
    id: 5,
    name: "Operator05",
    value: "Operator05",
  },
  {
    id: 6,
    name: "Operator06",
    value: "Operator06",
  },
  {
    id: 7,
    name: "Operator07",
    value: "Operator07",
  },
  {
    id: 8,
    name: "Operator08",
    value: "Operator08",
  },
  {
    id: 9,
    name: "Operator09",
    value: "Operator09",
  },
  {
    id: 10,
    name: "Operator10",
    value: "Operator10",
  },
  {
    id: 11,
    name: "Operator11",
    value: "Operator11",
  },
  {
    id: 12,
    name: "Operator12",
    value: "Operator12",
  },
  {
    id: 13,
    name: "Operator13",
    value: "Operator13",
  },
  {
    id: 14,
    name: "Operator14",
    value: "Operator14",
  },
  {
    id: 15,
    name: "Operator15",
    value: "Operator15",
  },
  {
    id: 16,
    name: "Operator16",
    value: "Operator16",
  },
  {
    id: 17,
    name: "Operator17",
    value: "Operator17",
  },
  {
    id: 18,
    name: "Operator18",
    value: "Operator18",
  },
  {
    id: 19,
    name: "Operator19",
    value: "Operator19",
  },
  {
    id: 20,
    name: "Operator20",
    value: "Operator20",
  },
  {
    id: 21,
    name: "Operator21",
    value: "Operator21",
  },
  {
    id: 22,
    name: "Operator22",
    value: "Operator22",
  },
  {
    id: 23,
    name: "Operator23",
    value: "Operator23",
  },
  {
    id: 24,
    name: "Operator24",
    value: "Operator24",
  },
];

const Staff = () => {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [color, setColor] = useState("#563d7c");
  const [role, setRole] = useState("");

  const [updateLogin, setUpdateLogin] = useState("");
  const [updatePassworrd, setUpdatePassword] = useState("");
  const [updateColor, setUpdateColor] = useState("");
  const [updateRole, setUpdateRole] = useState("");
  const [rows, setRows] = useState([]);
  const [stafflist, setStaffList] = useState([]);
  const [singleStaff, setSingleStaff] = useState({});
  const [staffSelected, setStaffSelected] = useState("");
  const [validated, setValidated] = useState(false);
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoadinig] = useState(false);
  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    let url = `${endPoints.api.get_All_Staff}`;
    await getAllData(url)
      .then((response) => {
        console.log("get_All_Staff", response);
        if (response.status === "success") {
          setStaffList(response.data);
          // setPending(false);
        } else {
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const singleStaffId = async (id) => {
    if (id == "staff") {
      setSingleStaff({});
      return;
    }
    let url = `${endPoints.api.get_Single_Staff}/${id}`;
    await getAllData(url)
      .then((response) => {
        console.log("get_Single_Staff", response.status);
        if (response.status === "success") {
          setSingleStaff(response.data);
          // setPending(false);
          const { login, passwd, type, color } = response.data;
          setUpdateLogin(login);
          setUpdatePassword(passwd);
          setUpdateColor(color);
          setUpdateRole(type);
        } else {
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const onChangeStaff = (e) => {
    setStaffSelected(e.target.value);
    singleStaffId(e.target.value);
  };

  const createStaff = async (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }

    let data = {
      login: login,
      passwd: password,
      color: color,
      type: role,
    };

    let url = `${endPoints.api.Create_Staff}`;
    setIsLoadinig(true);
    await addData(url, data)
      .then((response) => {
        console.log("get_Single_Staff", response);
        setIsLoadinig(false);
        if (response.data.status === "success") {
          SuccesToast("Created Successfully")
          setSingleStaff(response.data);
          fetchUserData();
          // setPending(false);
          const { login, passwd, type, color } = response.data;
          setLogin("");
          setPassword("");
          setColor(color);
          setRole("");
        } else {

        }
      })
      .catch((error) => {
        console.error(error);
        setIsLoadinig(false);
      });
  };
  const updateStaff = async (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }

    let data = {

      id_staff: staffSelected,
      login: updateLogin,
      passwd: updatePassworrd,
      color: updateColor,
      type: updateRole

    };

    let url = `${endPoints.api.Update_Staff}`;
    setIsLoadinig(false);
    await addData(url, data)
      .then((response) => {
        console.log("update_Res", response);
        setIsLoadinig(false);
        if (response.status === "success") {
          setSingleStaff(response.data);
          // setPending(false);
          SuccesToast("Updated Successfully")
          const { login, passwd, type, color } = response.data;
          setUpdateLogin(login);
          setUpdatePassword(passwd);
          setUpdateColor(color);
          setUpdateRole(type);
        } else {
        }
      })
      .catch((error) => {
        console.error(error);
        setIsLoadinig(false);
      });
  };
  const deleteStaff = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }

    let data = {

      id_staff: staffSelected,
      login: updateLogin,
      passwd: updatePassworrd,
      color: updateColor,
      type: updateRole

    };
    let url = `${endPoints.api.Delete_Staff}`;
    setIsLoadinig(false);
    addData(url, data)
      .then((response) => {
        console.log("update_Res", response);
        setIsLoadinig(false);
        if (response.status == 200) {
          setSingleStaff(response.data);
          fetchUserData();
          SuccesToast("Deleted Successfully")

        } else {
        }
      })
      .catch((error) => {
        console.error(error);
        setIsLoadinig(false);
      });
  }
  return (
    <>
      <div className="main">
        <div id="Sportbook" style={{padding:'0px'}}>
          <Toaster></Toaster>
          {isLoading && <Loader spinner={true} visible={isLoading} />}
          <div className="container-fluid">
            <div className="card-deck row">
              <div className="col-md-6" style={{}}>
                <div className="full_manager_div p-4">
                  <h4 className="mb-4 box_effect box_effect_font">Create Staff</h4>
                  <Form noValidate validated={validated} onSubmit={createStaff}>
                    <Form.Group as={Row} className="mb-3" controlId="EMAIL">
                      <Form.Label column sm="2">
                        Login
                      </Form.Label>
                      <Col sm="10">
                        <Form.Control
                          required
                          value={login}
                          onChange={(e) => setLogin(e.target.value)}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please enter valid login name
                        </Form.Control.Feedback>
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3" controlId="PASSWORD">
                      <Form.Label column sm="2">
                        Password
                      </Form.Label>
                      <Col sm="10">
                        <Form.Control
                          required
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          placeholder="Password"
                        />
                        <Form.Control.Feedback type="invalid">
                          Please enter Password
                        </Form.Control.Feedback>
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="2">
                        Color
                      </Form.Label>
                      <Col sm="10">
                        <Form.Control
                          type="color"
                          defaultValue="#563d7c"
                          title="Choose your color"
                          value={color}
                          onChange={(e) => setColor(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="2">
                        Type of role
                      </Form.Label>
                      <Col sm="10">
                        <Form.Select
                          value={role}
                          onChange={(e) => setRole(e.target.value)}
                        >
                          {RoleData.map((dropdown) => {
                            return (
                              <option dropdown={dropdown} value={dropdown.id}>
                                {dropdown.name}
                              </option>
                            );
                          })}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                    <Button
                      variant="secondary"
                      size="sm"
                      style={{ width: "100%" }}
                      type="submit"
                    >
                      Create
                    </Button>
                  </Form>
                </div>
              </div>
              <div className="col-md-6" style={{}}>
                <div className="full_manager_div p-4">
                  <h4 className="mb-4  box_effect box_effect_font">Update Detail Staff</h4>
                  <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm="2">
                      Choose
                    </Form.Label>
                    <Col sm="10">
                      <Form.Select
                        aria-label="Default select example"
                        value={staffSelected}
                        onChange={(e) => onChangeStaff(e)}
                      >
                        <option value="staff">Select the Staff</option>
                        {stafflist.map((dropdown) => {
                          return (
                            <option dropdown={dropdown} value={dropdown.id_staff}>
                              {dropdown.login}
                            </option>
                          );
                        })}
                      </Form.Select>
                    </Col>
                  </Form.Group>
                  {singleStaff?.id_staff && (
                    <Form>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        controlId="formPlaintextEmail"
                      >
                        <Form.Label column sm="2">
                          Login
                        </Form.Label>
                        <Col sm="10">
                          <Form.Control
                            value={updateLogin}
                            onChange={(e) => setUpdateLogin(e.target.value)}
                          />
                        </Col>
                      </Form.Group>

                      <Form.Group
                        as={Row}
                        className="mb-3"
                        controlId="formPlaintextPassword"
                      >
                        <Form.Label column sm="2">
                          Password
                        </Form.Label>
                        <Col sm="10">
                          <Form.Control
                            // type="password"
                            placeholder="Password"
                            value={updatePassworrd}
                            onChange={(e) => setUpdatePassword(e.target.value)}
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        controlId="formPlaintextPassword"
                      >
                        <Form.Label column sm="2">
                          Color
                        </Form.Label>
                        <Col sm="10">
                          <Form.Control
                            type="color"
                            id="exampleColorInput"
                            defaultValue="#563d7c"
                            title="Choose your color"
                            value={updateColor}
                            onChange={(e) => setUpdateColor(e.target.value)}
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        controlId="formPlaintextPassword"
                      >
                        <Form.Label column sm="2">
                          Type of role
                        </Form.Label>
                        <Col sm="10">
                          <Form.Select
                            aria-label="Default select example"
                            value={updateRole}
                            onChange={(e) => setUpdateRole(e.target.value)}
                          >
                            {RoleData.map((dropdown) => {
                              return (
                                <option
                                  dropdown={dropdown}
                                  value={dropdown.value}
                                >
                                  {dropdown.name}
                                </option>
                              );
                            })}
                          </Form.Select>
                        </Col>
                      </Form.Group>
                      <div style={{ display: "flex" }}>
                        <Button
                          variant="secondary"
                          size="sm"
                          className="right-space10"
                          style={{ width: "100%" }}
                          onClick={updateStaff}
                        >
                          Update
                        </Button>
                        <Button
                          variant="secondary"
                          size="sm"
                          className="left-space10"
                          style={{ width: "100%" }}
                          onClick={deleteStaff}
                        >
                          Delete
                        </Button>
                      </div>
                    </Form>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Staff;
